import axios from 'axios'
import { API_URL, CLIENT_ID, CLIENT_SECRET } from '../constants';

const httpClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
});

export const login = (email, password) => {
  return httpClient.post('/oauth/token', {
    'client_id': CLIENT_ID,
    'grant_type': 'password',
    'client_secret': CLIENT_SECRET,
    'username': email,
    'password': password
  })
}

export const refreshToken = (refreshToken) => {
  return httpClient.post('/oauth/token', {
    'client_id': CLIENT_ID,
    'grant_type': 'refresh_token',
    'client_secret': CLIENT_SECRET,
    'refresh_token': refreshToken
  })
}